<script setup lang="ts">
import type { Schemas } from '@shopware/api-client/api-types/storeApiTypes';

const props = defineProps<{
    block: Schemas['CmsBlock'];
}>();

const { getSlotContent } = useCmsBlock(props.block);

const config = getSlotContent('config') as Schemas['CmsSlot'];
const image = getSlotContent('image') as Schemas['CmsSlot'];
</script>

<template>
    <div class="mb-4 h-[unset] bg-neutral-250 py-8 md:mb-12 md:h-128 md:py-12">
        <div class="container relative flex h-full flex-col items-center justify-center md:flex-col">
            <CmsLoader
                :content="config"
                class="md:order[unset] order-2"
            />

            <CmsLoader
                :content="image"
                class="md:order[unset] order-1 mb-4 md:mb-0 md:h-full md:max-h-128 md:w-auto md:self-end [&>*]:!min-h-[unset]"
            />
        </div>
    </div>
</template>

<style>
.cms-block-hero-banner .cms-element-image .relative {
    @apply md:h-full md:w-auto;
}
</style>
